import * as React from 'react';

const PauseIcon = (props) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20Z"
      fill="#6B3EB4"
    />
    <path
      d="M16 16C16 15.4477 16.4477 15 17 15H18C18.5523 15 19 15.4477 19 16V24C19 24.5523 18.5523 25 18 25H17C16.4477 25 16 24.5523 16 24V16Z"
      fill="white"
    />
    <path
      d="M22 16C22 15.4477 22.4477 15 23 15H24C24.5523 15 25 15.4477 25 16V24C25 24.5523 24.5523 25 24 25H23C22.4477 25 22 24.5523 22 24V16Z"
      fill="white"
    />
  </svg>
);
export default PauseIcon;
